import { appSetLoading } from "store/actions/appAction";
import { setOpeningBalanceData, setOpeningBalanceId } from "store/actions/openingBalanceAction";
import axios from "../axios/axios";
import { errorDispatcher } from "helpers";
import shortid from "shortid";
import { apiSetAlert } from "./appApi";
import getCurrency from "helpers/currencyHelper";
import { info } from "sass";

export const apiGetOpeningBalance = (token, callBack) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`/accountings/openingBalance`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const op = response.data.openingBalance;
      const bills = normalizeProducts(op.bills);
      const cheques = normalizeCheques(op.cheques);
      const others = op.accounting.Accounting_Items.filter(
        (x) => ![34, 95, 96, 110].includes(x.AccountTypeId)
      );
      const res = bills.concat(cheques).concat(normalizeOpeningBalance(others));
      // dispatch(setOpeningBalanceData(res));
      dispatch(setOpeningBalanceId(op.accounting.id));
      dispatch(appSetLoading(false));
      callBack(res)
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiSetOpeningBalance = (props) => (dispatch, getState) => {
  let { openingBalance, token } = props;
  if (Array.isArray(props)) {
    const info = [
      { key: "بانک", accountTypeId: 89 },
      { key: "صندوق", accountTypeId: 88 },
      { key: "بدهکاران", accountTypeId: 93 },
      { key: "تنخواه", accountTypeId: 87 },
      { key: "موجودی کالا", accountTypeId: 34 },
      { key: "اسناد دریافتنی", accountTypeId: 95 },
      { key: "اسناد در حال وصول", accountTypeId: 96 },
      { key: "سایر دارایی ها", accountTypeId: 41 },
      { key: "بستانکاران", accountTypeId: 109 },
      { key: "اسناد پرداختنی", accountTypeId: 110 },
      { key: "سایر بدهی ها", accountTypeId: null },
    ]
    const accountingItems = []
    info.map(x => {
      const data = props.filter(y => y.key === x.key)
      switch (x.key) {
        case 'بانک':
          for (const currrow of data) {
            const row = currrow.main
            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountBank,
              detailAccountingCode: row.detailAccountingCodeBank,
              isCreditor: false
            })

          }
          break
        case 'صندوق':
          for (const currRow of data) {
            const row = currRow.main
            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountCash,
              detailAccountingCode: row.detailAccountingCodeCash,
              isCreditor: false
            })

          }
          break
        case 'بدهکاران':
          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountDebtor,
              detailAccountingCode: row.detailAccountingCodePerson,
              isCreditor: false
            })

          }
          break
        case 'تنخواه':
          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountTanKhah,
              detailAccountingCode: row.detailAccountingCodeTankhah,
              isCreditor: false
            })

          }
          break
        case 'موجودی کالا':

          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountProduct,
              quantity: row.quantity,
              wareHouseaccountingCode: row.wareHouseaccountingCode,
              detailAccountingCode: row.detailAccountingCodeProduct,
              isCreditor: false
            })

          }
          break
        case 'اسناد دریافتنی':

          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountRecive,
              chequeBranch: row.chequeBranchRecive,
              chequeDate: row.chequeDateRecive,
              chequeIssuingBank: row.chequeIssueBankRecive,
              detailAccountingCode: row.detailAccountingCodePersonRecive,
              isCreditor: false
            })

          }
          break
        case 'اسناد در حال وصول':


          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              personAccountingCode: row.detailAccountingCodePersonReceiving,
              chequeNumber: row.chequeNumberReciveing,
              amount: row.amountReciveing,
              chequeDate: row.chequeDateReciveing,
              chequeIssuingBank: row.chequeIssueBankReciveing,
              chequeBranch: row.chequeBranchReciveing,
              detailAccountingCode: row.chequeBankReciveing,
              isCreditor: false
            })

          }
          break
        case 'سایر دارایی ها':
          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              isCreditor: true,
              amount: row.amountCreditor,
              detailAccountingCode: row.detailAccountingCodePersonCreditor,
              description: row.descriptionOtherAssets
            })

          }
          break
        case "بستانکاران":
          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountCreditor,
              detailAccountingCode: row.detailAccountingCodePersonCreditor,
              isCreditor: true
            })

          }
          break
        case "اسناد پرداختنی":
          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeId: x.accountTypeId,
              amount: row.amountPayment,
              payTo: row.recieverPayment,
              chequeIssuingBank: "",
              detailAccountingCode: row.detailAccountingCodeBankPayment,
              chequeNumber: row.numberPayment,
              isCreditor: true
            })

          }
          break
        case "سایر بدهی ها":
          for (const currRow of data) {
            const row = currRow.main

            accountingItems.push({
              accountTypeCode: row.accountingCodedebtor,
              isCreditor: row.creditordebtor && row.creditordebtor > 0,
              amount: row.creditordebtor && row.creditordebtor > 0 ? row.creditordebtor : row.debtordebtor,
              detailAccountingCode: row.tafsilCodedebtor,
              description: row.descriptiondebtor
            })
            break
          }
      }
    })

    console.log(accountingItems)
    openingBalance={}
    openingBalance["data"]=accountingItems
  }
  if (!openingBalance ) return;

  dispatch(appSetLoading());
  const id = openingBalance.id;
  const req = id ? axios.put : axios.post;
  const data = { accountingItems: openingBalance.data, date: openingBalance.date };
  req(`/accountings/openingBalance${id ? "/" + id : ""}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      dispatch(appSetLoading(false));
      dispatch(apiSetAlert(response.data.message, "success"));
      window.location.reload()
    })
    .catch((error) => errorDispatcher(error, dispatch));
};

export const apiDeleteOpennigBlance = (props, token) => (dispatch, getState) => {
  const { openingBalance, token, callBack } = props;

  if (!openingBalance) return;
  dispatch(appSetLoading());
  const id = openingBalance.id;
  const req = axios.delete;
  const data = { deleteChequeAccounting: openingBalance.deleteChequeAccounting };

  req(`/accountings/openingBalance${id ? "/" + id : ""}`, {
    headers: { Authorization: `Bearer ${token}` },
    data
  })
    .then((response) => {
      dispatch(appSetLoading(false));
      dispatch(apiSetAlert(response.data.message, "success"));
      window.location.reload()
    })
    .catch((error) => errorDispatcher(error, dispatch));
};

export function normalizeOpeningBalance(data) {
  if (!data || data.length === 0) return [];
  const now = Intl.DateTimeFormat("fa-IR-u-nu-latn").format(Date.now());
  return data
    .filter((x) => getType(x.AccountTypeId, x.Account_Type.parentId))
    .map((item) => ({
      account: item.Account_Type,
      accountTypeId: item.AccountTypeId,
      type: getType(item.AccountTypeId, item.Account_Type.parentId),
      id: item.detail_id || item.id,
      ind: shortid.generate(),
      detailId: item.detail_id,
      price: item.amount || 0,
      currencyPrice: item.currency_amount,
      creditor: item.isCreditor ? item.amount : 0,
      debtor: item.isCreditor ? 0 : item.amount,
      title: item.AccountTypeId === 49 ? item.description : item.detail || item.accountType,
      currency: getCurrency().defCur.en_title,
      date: now,
      delegationDate: now,
    }));
}

function normalizeProducts(data) {
  if (!data || data.length === 0) return [];
  return data.map((x) => {
    const count = x.quantity || 1;
    const price = x.price || 0;
    return {
      accountTypeId: 34,
      type: "product",
      ind: shortid.generate(),
      title: x.productName,
      unit: x.unit,
      barcode: x.code,
      id: x.productId,
      detailId: x.productId,
      warehouse: x.warehouseName,
      warehouseId: x.warehouseId,
      count,
      price,
      totalPrice: price * count,
    };
  });
}

function normalizeCheques(data) {
  if (!data || data.length === 0) return [];

  return data.map((x) => {
    const accountTypeId = x.type === "payment" ? 110 : x.status === "normal" ? 95 : 96;
    const type = getType(accountTypeId);
    const ind = shortid.generate();
    let res = {
      accountTypeId,
      type,
      ind,
      id: x.paymented + ind,
      title: x.paymented,
      // price: x.amount,
      date: x.createdAt,
      delegationDate: x.dueDate,
      bank: x.bank,
      payTo: x.payTo,
      branch: x.branch,
      number: +x.number,
      currency: x.currency || "ريال",
      chequeId: x.id
    };
    if ([95, 110].includes(accountTypeId)) res.detailId = x.payment_id;
    if (accountTypeId === 110) {
      res.creditor = x.amount;
    }
    if (accountTypeId === 95) {
      res.debtor = x.amount;
    }
    if (accountTypeId === 96) {
      res.personId = x.payment_id;
      res.detailId = x.receive_id;
      res.onGoingDocBank = x.received;
      res.debtor = x.amount;
    }
    return res;
  });
}

export const otherAssetsTypeIds = [
  35, 36, 37, 40, 90, 91, 92, 94, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108,
];
export const otherDebtsTypeIds = [11, 43, 44, 12, 45, 111, 112, 113, 114, 115, 116, 117, 118, 119];
export const typeIds = {
  fund: 87,
  cashier: 88,
  bank: 89,
  product: 34,
  debtor: 93,
  receivableDoc: 95,
  onGoingDoc: 96,
  creditor: 109,
  payableDoc: 110,
  capital: 49,
  LegalReserve: 51,
  accumulatedProfitOrLoss: 54,
};

export function getType(id, parentId) {
  if (otherAssetsTypeIds.includes(id)) return "otherAsset";
  if (otherDebtsTypeIds.includes(id) || otherDebtsTypeIds.includes(parentId)) return "otherDebt";
  return Object.keys(typeIds).find((key) => typeIds[key] === id);
}

export function getTypeId(type) {
  return typeIds[type];
}
